import { VariantBadge } from '../models/product/dto/variant-badge';
import { RegexUtils } from './regex-utils';

export class FilterUtils {
  static keepPlantLifeTaggedBadges = (badge: VariantBadge | null): boolean => {
    return badge?.name?.toUpperCase()?.includes('[PL]') ?? false;
  };

  static removeBadgesWith86Keyword = (badge: VariantBadge | null): boolean => {
    return !badge?.name?.includes('86');
  };

  static removeBadgesWithNameThatHasCheapWeed = (badge: VariantBadge | null): boolean => {
    const badgeName = badge?.name?.toLowerCase();
    if (!badgeName) return false;
    return !RegexUtils.cheapWeedRegex.test(badgeName);
  };
}
